import React from "react";
import { avatarUrl } from "../lib/api";

export function Avatar({ user, size = 40, className = "" }) {
  const url = avatarUrl(user);
  const initial = (user?.pseudo || "?").charAt(0).toUpperCase();
  return (
    <div
      className={`shrink-0 rounded-full overflow-hidden flex items-center justify-center font-display font-bold text-white ${className}`}
      style={{ width: size, height: size, background: "linear-gradient(135deg,#8B5CF6,#6D28D9)", fontSize: size * 0.4 }}
      data-testid="user-avatar"
    >
      {url ? <img src={url} alt={user?.pseudo} className="w-full h-full object-cover" /> : initial}
    </div>
  );
}
